import React from "react";
import Svg, { Path } from "react-native-svg";

const ArrowLeftIcon = ({ width, height, color }) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 20 18"
      preserveAspectRatio="xMidYMin meet"
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.63606 0.564173C9.51996 0.445732 9.38204 0.351765 9.23019 0.287647C9.07835 0.22353 8.91556 0.190527 8.75117 0.190527C8.58677 0.190527 8.42398 0.22353 8.27214 0.287647C8.1203 0.351765 7.98237 0.445732 7.86627 0.564173L0.36719 8.19514C0.250796 8.31328 0.15845 8.45363 0.0954416 8.60815C0.0324332 8.76266 0 8.92831 0 9.0956C0 9.26289 0.0324332 9.42853 0.0954416 9.58305C0.15845 9.73756 0.250796 9.87791 0.36719 9.99605L7.86627 17.627C8.10096 17.8658 8.41927 18 8.75117 18C9.08307 18 9.40137 17.8658 9.63606 17.627C9.87075 17.3882 10.0026 17.0643 10.0026 16.7266C10.0026 16.3888 9.87075 16.0649 9.63606 15.8261L3.01937 9.0956L9.63606 2.36508C9.75245 2.24694 9.8448 2.10659 9.90781 1.95208C9.97082 1.79756 10.0032 1.63192 10.0032 1.46463C10.0032 1.29734 9.97082 1.13169 9.90781 0.977179C9.8448 0.822664 9.75245 0.682316 9.63606 0.564173Z"
        fill="black"
      />
      <Path
        d="M19.6336 8.19507C19.868 8.43358 19.9997 8.75708 19.9997 9.09439C19.9997 9.4317 19.868 9.75519 19.6336 9.9937C19.3992 10.2322 19.0813 10.3662 18.7498 10.3662L2.5018 10.3662C2.17032 10.3662 1.85242 10.2322 1.61803 9.9937C1.38363 9.75519 1.25195 9.4317 1.25195 9.09439C1.25195 8.75708 1.38363 8.43358 1.61803 8.19507C1.85242 7.95656 2.17032 7.82256 2.5018 7.82256L18.7498 7.82256C19.0813 7.82256 19.3992 7.95656 19.6336 8.19507Z"
        fill="black"
      />
    </Svg>
  );
};

ArrowLeftIcon.defaultProps = {
  width: 20,
  height: 18,
  color: "#000000",
};

export default ArrowLeftIcon;
